<template>
  <el-dropdown
    class="langs-select"
    @command="handleCommand"
  >
    <span class="el-dropdown-link langs-select__selected">
      {{ checkedLangName }}
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="lang in availableLangs"
        :key="lang.value"
        :disabled="lang.value === checkedLang"
        :command="lang.value"
      >
        {{ lang.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import Cookies from 'js-cookie';
  import config from '@/config'
  import {AVAILABLE_LANGS} from '@/constants'

  export default {
    name: 'LangCheck',
    props: {
      needConfirmOnChange: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        langs: [
          {
            value: 'ru',
            label: 'Русский'
          },
          {
            value: 'en',
            label: 'English'
          },
          {
            value: 'es',
            label: 'Español'
          },
          {
            value: 'tr',
            label: 'Türkçe'
          },
          {
            value: 'kz',
            label: 'Қазақ'
          },
          {
            value: 'cn',
            label: '中文'
          },
          {
            value: 'uz',
            label: 'O\'zbekcha'
          },
          {
            value: 'in',
            label: 'हिंदी'
          }
        ],
        AVAILABLE_LANGS: config(AVAILABLE_LANGS)
      }
    },
    computed: {
      checkedLangName () {
        return this.langs.find(lang => lang.value === this.checkedLang).value.toUpperCase();
      },
      checkedLang () {
        return this.$store.state.lang || 'en'
      },
      availableLangs () {
        if (this.AVAILABLE_LANGS === undefined || this.AVAILABLE_LANGS === '') {
          return this.langs;
        }

        return this.langs.filter(item => this.AVAILABLE_LANGS.includes(item.value))
      }
    },
    methods: {
      async handleCommand (lang) {
        if (this.needConfirmOnChange) {
          setTimeout(() => {
            this.$confirm(this.$t('labels.lang_change_dialog_text'), this.$t('labels.attention'), {
              confirmButtonText: this.$t('labels.yes'),
              cancelButtonText: this.$t('labels.cancel'),
              type: 'warning'
            })
              .then(async _ => {
                Cookies.set('lang_checked', lang);

                if (this.$store.state.user.user && Object.entries(this.$store.state.user.user).length) {
                  await this.$store.dispatch('user/userProfileUpdate', {lang})
                }

                window.location.reload(false);
              })
              .catch(_ => {});
          }, 250)
        } else {
          Cookies.set('lang_checked', lang);
          this.$i18n.locale = lang
          this.$store.commit('setLang', lang);
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .langs-select {
    white-space: nowrap;

    &__selected {
      background: url('/static/img/icons/globe.svg') 0 0 no-repeat;
      padding: 1px 0 1px 28px;
    }
  }
</style>